<template lang="pug">
  form.b-password-recovery-form(@submit.prevent="submit")
    h1.auth-form-title Восстановление пароля
    p.auth-form-desc(v-if="recoveryEmailIsSent") Сообщение с сылкой для восстановления отправлено на Вашу электронную почту
    template(v-if="!recoveryEmailIsSent")
      p.auth-form-desc Введите адрес электронной почты
      CommonInput._input(
        v-model="fields.email.value"
        v-bind="fields.email"
        @change="inputChanged"
      )
      ._btns
        router-link(:to="{ name: 'auth-login' }")._back.auth-link(href="login.html") Отмена
        button.b-btn.-green Восстановить пароль
</template>

<script>
import CommonInput from '@/components/CommonInput.vue';

import Ban from '@/utils/ban';
import form from '@/utils/form';
import api from '@/api/auth';

export default {
  name: 'AuthPasswordRecoveryForm',
  components: { CommonInput },
  data() {
    return {
      recoveryEmailIsSent: false,
      ban: null,
      fields: {
        email: form.createFieldObject('email', 'E-mail', '', { required: 'Это поле обязательно', email: 'E-mail некорректный' }),
      },
    };
  },
  methods: {
    inputChanged() {
      form.validate(this.fields);
    },
    submit() {
      this.ban?.stop(); // eslint-disable-line no-unused-expressions

      form.validate(this.fields);

      if (form.hasErrors(this.fields)) {
        return;
      }

      api.requestPasswordRecoveryEmail(form.getValues(this.fields))
        .then(() => { this.recoveryEmailIsSent = true; })
        .then(this.callback);
    },
    callback(responseData) {
      switch (responseData?.message) {
        case 'Email not found.':
        case 'Invalid credentials.':
          this.fields.email.error = 'Данного e-mail нет в системе';
          break;

        case 'Username is banned.':
          this.ban = new Ban(
            responseData.banTimeLeft,
            (e) => { this.fields.email.error = e; },
            'Вы ввели логин или пароль, которых нет в системе 3 раза. Следующая попытка восстановления пароля возможна через #TIME#. Если вы забыли логин или e-mail, обратитесь в техподдержку.',
          );
          this.ban.run();
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.password-recovery-form {
  &__input {
    margin-bottom: 16px;
  }

  &__btns {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  &__back {
    color: var(--color-middle-gray);
    font-size: 12px;
    font-weight: 500;
    line-height: 15px;
  }

  @media (max-width: 768px) {
    &__btns,
    &__input {
      width: 314px;
    }
  }

  @media (max-width: 500px) {
    &__btns,
    &__input {
      width: 100%;
    }
  }
}
</style>
